import * as L from "react";
import { forwardRef as t } from "react";
const l = t(function(e, r) {
  return /* @__PURE__ */ L.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ L.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M21.77 17.7944H3L6.84932 10.0958L9.6172 9.03265L11.7434 5L21.77 17.7944ZM4.22814 17.0245H20.157L16.5826 12.882L15.5378 12.3687L14.1814 10.1691L14.8596 12.3687L14.8413 15.1366L14.548 12.222L13.4665 9.72921L12.4767 9.06929L12.385 10.0041L12.0001 10.1691L11.4135 9.67422L10.7353 10.1691L9.50721 10.2241L8.7373 11.5438L7.96747 12.332L7.23427 15.5398L7.6925 12.0938L8.49904 10.7923L7.41753 11.7822L6.73933 13.0469L4.22814 17.0245Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  l as WinterSports
};
